/**
 * 1006 — 派任务成功提示的说明句按企微绑定状态如实说。
 * 此前一律写「任务卡片已发到员工的企业微信」,租户没绑企微时卡片根本发不出去,话是假的。
 *
 * - `true`(已绑):已发到企业微信;
 * - `false`(确认没绑):任务已创建,绑定后员工才能收到;
 * - `undefined`(查不到):不说发没发,只说去哪练。
 */
export function taskCreatedDescKey(
  wecomBound: boolean | undefined
): "toast.taskCreatedWhere" | "toast.taskCreatedNoWecom" | "toast.taskCreatedWecomUnknown" {
  if (wecomBound === true) return "toast.taskCreatedWhere";
  if (wecomBound === false) return "toast.taskCreatedNoWecom";
  return "toast.taskCreatedWecomUnknown";
}
